import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output
} from '@angular/core';
import { environment } from '../../../../environments/environment';
import { IStatusMessage, ResponseStatus } from '../../../shared';
import { FileFormatModel } from '../store/file-format.model';
import * as fromShared from '../../../shared';
import { SelectItem } from '../../../shared/efaact-primeng.module';
import { LoggingService } from '../../../shared/services/logging/logging.service';
import { IShowErrors } from '../../../shared/errors-sidenav';

@Component({
    selector: 'ef-third-party-payroll-file-format',
    templateUrl: './third-party-payroll-file-format.component.html',
    styleUrls: ['./third-party-payroll-file-format.component.scss'],
    standalone: false
})
export class ThirdPartyPayrollFileFormatComponent implements OnInit {
    dropdownItemHeight = environment.dropdownItemHeight;
    public editing: FileFormatModel = {} as FileFormatModel;
    selected: FileFormatModel[] = [];
    cloned: { [i: number]: FileFormatModel } = {};
    @Input() items: FileFormatModel[];
    @Input() columns: SelectItem[];
    private _selectedError: IStatusMessage;
    @Input() public set selectedError(value: IStatusMessage) {
        if (!value) {
            return;
        }
        if (this._selectedError && this._selectedError.MsgEntityID) {
            const oldRow = document.getElementById(
                `row-${this._selectedError.MsgEntityID.toString()}`
            );
            if (oldRow) {
                oldRow.classList.remove('highlight');
                oldRow.classList.remove('highlight-warning');
                oldRow.classList.remove('highlight-danger');
            }
        }
        this._selectedError = value;
        if (!(value && value.MsgEntityID)) {
            return;
        }
        const row = document.getElementById(
            `row-${value.MsgEntityID.toString()}`
        );
        if (!row) {
            return;
        }
        row.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'nearest'
        });
        row.classList.add('highlight');
        if (value.StatusCode === ResponseStatus.Warning) {
            row.classList.add('highlight-warning');
        }
        if (value.StatusCode === ResponseStatus.Failed) {
            row.classList.add('highlight-danger');
        }
    }
    @Output() Save = new EventEmitter<FileFormatModel[]>();
    @Output() Select = new EventEmitter<FileFormatModel>();
    @Output() public ShowError = new EventEmitter<IShowErrors>();
    public get selectedError(): IStatusMessage {
        return this._selectedError;
    }
    constructor(
        private log: LoggingService,
        private cdRef: ChangeDetectorRef
    ) {}

    ngOnInit(): void {}
    onStatusClick(item: FileFormatModel) {
        this.ShowError.emit({ open: true, MsgEntityID: item.id.toString() });
    }
    onRowEditInit(item: FileFormatModel) {
        this.cloned[item.id] = { ...item };
        this.editing = item;
        this.selected = fromShared.uniqBy(
            [...(this.selected || []), item],
            x => x.id
        );
    }
    onRowEditSave(item: FileFormatModel) {
        this.log.verbose({
            type: 'ThirdPartyPayrollFileFormatComponent:onRowEditSave',
            item,
        });
        item.Status.StatusCode = ResponseStatus.Loading;
        item.Status.Message = 'Saving';

        this.Save.next([item]);
        delete this.cloned[item.id];
        delete this.editing;
    }
    onRowEditCancel(item: FileFormatModel) {
        const index = this.items.findIndex(x => x.id === item.id);
        if (index >= 0) {
            this.items.splice(index, 1, this.cloned[item.id]);
        }
        this.items = [...this.items];
        this.selected = [];

        delete this.cloned[item.id];
        delete this.editing;
    }
    onRowSelect($event) {
        this.Select.next($event.data);
    }
    onRowReorderHandler($event: { dragIndex: number; dropIndex: number }) {
        // TODO: save everything after the drop index
        const start = Math.min($event.dragIndex, $event.dropIndex);
        const stop = Math.max($event.dragIndex, $event.dropIndex);
        this.log.verbose({
            type: 'ThirdPartyPayrollFileFormatComponent:onRowReorderHandler',
            $event,
            start,
            stop,
            items: this.items
        });
        this.items.splice(
            $event.dropIndex,
            0,
            this.items.splice($event.dragIndex, 1)[0]
        );
        // this.items[$event.dragIndex].sequence = $event.dropIndex;
        for (let i = start; i < this.items.length - 1; i++) {
            this.items[i].Sequencenbr = i;
        }
        this.Save.next(this.items.slice(start, stop + 1));
        // this.cdRef.detectChanges();
    }
}
